import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingChipsList from '@spotahome/ui-library/src/tenant/components/ListingChipsList';

const openPropertyRulesSimplifiedModal = ({
  propertyFeaturesChips = [],
  fullscreenOnMobile = false
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('property.rule.main.title'),
    body: (
      <>
        {propertyFeaturesChips.length > 0 && (
          <div className="property-rules-simplified-modal__section">
            <ListingTitle role="tertiary">
              {trans('property.rule.propertyRules.title')}
            </ListingTitle>
            <ListingChipsList chipList={propertyFeaturesChips} />
          </div>
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openPropertyRulesSimplifiedModal;
